// en.js
export default {
  lang: {
    // 会员码页面
    home: '首頁',
    normalMember: '普通會員',
    vipMember: 'VIP會員',
    superVip: 'Super VIP會員',
    deluxeClue: 'Deluxe Clue會員',
    earnedPoints: '所得積分',
    membershipCode: '會員碼',
    expire: '到期',
    accumulatedConsumption: '累積消費',
    spending: '再消費',
    todaySpending: '或當日消費滿',
    upgradeLevel: '可升至',
    stayLevel: '可保級',
    yuan: '元',
    
    // 积分页面
    pointsFlow: '积分流水',
    availableIntegral: '可用积分',
    integralDetail: '积分明细',
    ofwhich: '其中',
    points: '积分',
    will: '将在',
    expired: '过期',

    // 历史优惠券
    historicalCoupon: '歷史優惠券',
    all: '全部',
    used: '已使用',
    alreadyExpired: '已過期',

    // 购物记录
    orderLists: '購物記錄',
    originOrderCode: '原訂單號',
    actualPayment: '實際付款',
    orderGoodsName: '訂單商品名',
    pleaseEnterGoodsName: '請輸入商品名稱',
    orderType: '訂單類型',
    order: '購物單',
    specialOrder: '正負單',
    refundOrder: '退款單',
    orderDate: '訂單日期',
    nearlyAMonth: '近一個月',
    nearlyThreeMonths: '近3個月',
    nearlySixMonths: '近6個月',
    startDate: '開始時間',
    endDate: '結束時間',
    orderSource: '訂單來源',

    // 优惠券
    myCoupon: '我的優惠券',
    couponDetail: '優惠券詳情',
    couponList: '優惠券列表',
    couponClaim: '領取優惠券',
    couponCode: '券Code',
    please: '請於',
    beforeUse: '前使用',
    usedFor: '可適用于',
    useInstructions: '券使用說明', 

    //按钮 
    ok: '確認',
    cancel: '取消',
    close: '關閉',
    reset: '重 置',
    query: '查 詢',
    confirmedUse: '確認使用',
    claim: '立即領取',
    // 提示
    copySuccess: '複製成功',
    copyFail: '複製失敗',
    noMore: '沒有更多了',
    confirmUseMsg: '確定使用後，優惠券將不可退回，請確認是否現在使用？',
    useSuccessfully: '使用成功！',
    receiveSuccess: '領取成功！',
    // 标题
    tip: '提示',
    filter: '篩選',
    selectStartDate: '選擇開始日期',
    selectEndDate: '選擇結束日期',
    chinaOnline: '小程序',
    chinaOffline: '大陆分店',
    hongkongOnline: '港澳网店',
    hongKongOffline: '港澳分店',
    usePlatform: '指定優惠券可用的平臺',
  }
}
  